import request from '@/utils/request'

export function insertBalance (data) {
  const method = 'post'
  const url = `/balance`
  return request({
    url, method, data
  })
}

export function updateBalance (data) {
  const method = 'put'
  const url = `/balance/${data.id}`
  return request({
    url,
    method,
    data
  })
}

export function getBalance (protocol_id, drug_id, lotto) {
  const method = 'get'
  const url = '/balance'
  return request({
    url,
    method,
    headers: {
      'x-filters': JSON.stringify({ protocol_id, drug_id, lotto}),
    }
  })
}

export function balanceDetails (drug_id, lotto, site_id) {
  const method = 'get'
  const url = `/balance/${drug_id}/${encodeURIComponent(encodeURIComponent(lotto))}/${site_id ? site_id : ''}`
  return request({
    url,
    method
  })  
}

export function drugOnSite({ site_id, drug_id }) {
  const method = 'get'
  const url = `/balance/drug_on_site/${site_id}/${drug_id}`
  return request({
    url,
    method
  })
}

export function balanceDrug(entity, search, item) {
  const method = 'get'
  const url = `/balance`
  let filters = {}
  if (item.site_id) {
    filters = { protocol_id: item.protocol_id, site_id: item.site_id, place: 'SITE' }
  } else {
    filters = { protocol_id: item.protocol_id, place: 'STORAGE' }
  }

  if (search) {
    filters['drug.name'] = `%${search}%`
  }

  return request({
    url,
    method,
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 1000 })
    }
  })
}
export function protocolDrugs (entity, search, item) {
  const method = 'get'
  const url = '/drug'

  if (!item.operation || !item.place || !(item.site_id || item.storage_id)) return Promise.resolve([])
  let filters = { protocol_id: item.protocol_id }
  if (search) {
    filters['name'] = `%${search}%`
  }

  if (item.storage_id) {
    filters['storage_id'] = item.storage_id
  }

  const ret = request({
    url, method,
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 1000 })
    },
    
  })

  return ret.then(r => {
    return {
      tot: r.tot,
      data:
        r.data = r.data.map(d => ({ drug_id: d.id, drug:  d }))
    }
  })
}


export function availableLotto (entity, search, item) {
  const method = 'get'
  const url = '/balance'
  if (!item.drug_id) return Promise.resolve([])
  let filters = { protocol_id: item.protocol_id, drug_id: item.drug_id }

  if (search) {
    filters['lotto'] = `%${search}%`
  }

  return request({
    url,
    method,
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: -1 })
    }
  })

}

export function availableLottoOnStorage (entity, search, item) {
  const method = 'get'
  const url = '/balance'
  if (!item.drug_id) return Promise.resolve([])
  let filters = { protocol_id: item.protocol_id, drug_id: item.drug_id, place: 'STORAGE' }

  if (search) {
    filters['lotto'] = `%${search}%`
  }

  return request({
    url,
    method,
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: -1 })
    }
  })

}

export function listDrugs (entity, search, item) {
  // if (!item) return Promise.resolve([])
  const method = 'get'
  const url = '/balance'

  if (!item.operation || !item.place || !(item.site_id || item.storage_id)) return Promise.resolve([])

  let filters = { protocol_id: item.protocol_id, place: item.place }


  
  if (item.drug_id) {
    filters.drug_id = item.drug_id
    if (search) {
      filters['lotto'] = `%${search}%`
    }    
  } else {
    if (search) {
      filters['drug.name'] = `%${search}%`
    }
  }

  if (item.operation === 'GET') {
    filters.n_pieces = '> 0'
  }

  if (item.place === 'SITE') {
    filters = { ...filters, site_id: item.site_id }
  } else {
    filters = { ...filters, 'drug.storage_id': item.storage_id, 'drug.always_available': '!=1' }
  }
  return request({
    url,
    method,
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 1000 })
    }
  })

}